module.exports = __webpack_public_path__ + "static/media/img-9.6512b1cc.jpg";